module.exports = __webpack_public_path__ + "img/interaction-bar-search-honda.f3b9d7d6.png";